export default {
  modal: {
    title: 'Olá',
    subtitle: 'Verificamos que o seu cadastro está incompleto.',
    description: 'Por favor, preencha as informações a baixo para prosseguir com a compra.',
    success: 'Obrigado! Seus dados foram atualizados com sucesso.'
  },
  buttons: {
    continue: 'CONTINUAR COMPRA',
    complete: 'FINALIZAR CADASTRO'
  },
};
